import Vue from 'vue';
import router from '@/router/index'
export default {
    state:{
      perfiles:{
        perfiles:[],
        perfiles_secciones:[],
        secciones:[]
      }
    },
    mutations: {
      setPerfiles(state,perfiles){
        state.perfiles.perfiles=perfiles;
      },
      setPerfiles_Secciones(state,perfiles_secciones){
        state.perfiles.perfiles_secciones=perfiles_secciones;
      },
      setSecciones(state,secciones){
        state.perfiles.secciones=secciones;
      }
    },
    actions: {
      Cambiar_Perfil_Usuario(context,perfil){
        Vue.http.post('perfiles/cambiar_perfil',{
          perfil:perfil
        })
        .then(respuesta=>{return respuesta.json()})
        .then(respuestaJson=>{
            if (respuestaJson.resp=='Excelente') {
              context.dispatch('Actualizar_Usuario',{
                usuario:respuestaJson.usuario,
                token:respuestaJson.token
              });
              localStorage.setItem('perfil_sistema', respuestaJson.usuario.perfil_sistema);
              // if (respuestaJson.usuario.perfil_sistema === '8') {
              //   router.push({name:"Ecommerce_Inicio"})
              // } else {
              // }
              router.push({name:"Dashboard"})
            }else{
              swal("¡Ups!", "Problemas para cambiar de perfil", "error");
            }
        })
        .catch(error=>{
          console.log(error)
            swal("¡Ups!", "Problemas para cambiar de perfil", "error");
        });
      },
      Consultar_Secciones(context,definir_permisos){

        Vue.http.get('perfiles/secciones/perfiles')
        .then(respuesta=>{return respuesta.json()})
        .then(respuestaJson=>{
          context.commit('setPerfiles',respuestaJson.perfiles);
          context.commit('setPerfiles_Secciones',respuestaJson.perfiles_secciones);
          context.commit('setSecciones',respuestaJson.secciones);
          if (definir_permisos==true) {
            context.dispatch('Definir_Permisos_Del_Usuario');
          }
        })
        .catch(error=>{
          //swal("¡Ups!", "Problemas para consultar los perfiles del empleado", "error");
        });
      }
    },
    getters: {
      getPerfiles(state){
        return state.perfiles.perfiles;
      },
      getPerfiles_Secciones(state){
        return state.perfiles.perfiles_secciones;
      },
      getSecciones(state){
        return state.perfiles.secciones;
      }
    },

}



// WEBPACK FOOTER //
// ./src/modules/perfiles.js